<template>
	<el-progress :percentage="50" :show-text="false" color="#fff100" define-back-color="rgb(35, 24, 21)"
		:stroke-width="3">
	</el-progress>
</template>

<script>
	export default {
		name: 'SectionDivider'
	}
</script>
